import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-cycle
import { getPlacesInfo } from '@/api/map';

const imageLayout = {
  layout: 'default',
  rectify: 0,
  column: 5,
  scale: 18,
  isTest: false,
  confirm: true,
};
const imageLayoutCache = localStorage.getItem('imageLayout');
if (imageLayout) {
  try {
    Object.assign(imageLayout, JSON.parse(imageLayoutCache));
  } catch (e) {
    console.error('read imageLayout localStorage error');
  }
}

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false,
    },
    device: 'desktop',
    theme: localStorage.getItem('theme-bi') || 'default',
    imageLayout,
    ajaxCount: 0,
    floorInfo: null,
    floorInfoInit: null,
    floorSvgSize: null,
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    CHANGE_THEME: (state, theme) => {
      state.theme = theme;
      localStorage.setItem('theme-bi', theme);
    },
    TOGGLE_FLOORINFO: (state, floorInfo) => {
      state.floorInfo = floorInfo;
    },
    FLOOR_INFO_INIT: (state, floorInfoInit) => {
      state.floorInfoInit = floorInfoInit;
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR');
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    ChangeTheme({ commit }, theme) {
      commit('CHANGE_THEME', theme);
    },
    ToggleFloorInfo({ commit }, floorInfo) {
      commit('TOGGLE_FLOORINFO', floorInfo);
    },
    getFloorInfoInit({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPlacesInfo(params).then((res) => {
          commit('FLOOR_INFO_INIT', res.data);
          resolve(res.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};

export default app;
